module.exports = __webpack_public_path__ + "img/pot-of-food.d9edd742.png";